/* Al Fagr — shared shop logic: cart helper, option picker, product cards */
(function () {
  'use strict';
  if (window.FagrShop) return;
  var D = document;
  var $ = function (s, r) { return (r || D).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || D).querySelectorAll(s)); };
  var isAr = (D.documentElement.lang || '').slice(0, 2) === 'ar';
  var T = function (en, ar) { return isAr ? ar : en; };
  var cfg = window.FagrCfg || {};
  var slug = function (s) { return String(s || '').toLowerCase().trim().replace(/\s+/g, '-'); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  function money(c) {
    var f = cfg.money || 'LE {{amount}}';
    var n = c / 100, s;
    if (/amount_no_decimals/.test(f)) s = Math.round(n).toLocaleString('en-US');
    else if (/amount_with_comma/.test(f)) s = n.toFixed(2).replace('.', ',');
    else s = n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\.00$/, '');
    return f.replace(/\{\{\s*\w+\s*\}\}/, s);
  }

  /* ---------- cart ---------- */
  var Cart = {
    add: function (items) {
      var body = {
        items: items.map(function (i) { return { id: i.id, quantity: i.quantity || 1 }; }),
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: location.pathname
      };
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok || res.j.status) throw new Error(res.j.description || res.j.message || 'Error');
          Cart.render(res.j);
          D.dispatchEvent(new CustomEvent('fagr:cart-add', { detail: { items: items, response: res.j } }));
          return res.j;
        });
    },
    render: function (j) {
      var d = $('cart-drawer');
      if (d && typeof d.renderContents === 'function' && j.sections) {
        try { d.classList.remove('is-empty'); d.renderContents(j); return; } catch (e) { /* fall through */ }
      }
      var n = $('cart-notification');
      if (n && typeof n.renderContents === 'function' && j.sections) { try { n.renderContents(j); return; } catch (e2) { /* fall through */ } }
      location.href = '/cart';
    }
  };

  /* ---------- product data helpers ---------- */
  function getData(el) {
    if (el.__fgp) return el.__fgp;
    var s = el.querySelector('script[data-fgp]');
    if (!s) return null;
    try { el.__fgp = JSON.parse(s.textContent); } catch (e) { return null; }
    return el.__fgp;
  }
  var colorsOf = function (P) { return P.ci >= 0 ? P.opt[P.ci].v : [null]; };
  function variantsFor(P, color, size) {
    return P.v.filter(function (v) { return (P.ci < 0 || v.o[P.ci] === color) && (P.si < 0 || v.o[P.si] === size); });
  }
  function pickVariant(P, color, size) {
    var l = variantsFor(P, color, size);
    return l.filter(function (v) { return v.a; })[0] || l[0] || null;
  }
  function sizesFor(P, color) {
    if (P.si < 0) return [];
    var seen = {}, out = [];
    P.v.forEach(function (v) {
      if (P.ci >= 0 && v.o[P.ci] !== color) return;
      var s = v.o[P.si];
      if (!(s in seen)) { seen[s] = out.length; out.push({ s: s, a: false }); }
      if (v.a) out[seen[s]].a = true;
    });
    return out;
  }
  function firstColor(P) {
    var cs = colorsOf(P);
    for (var i = 0; i < cs.length; i++) {
      if (P.v.some(function (v) { return v.a && (P.ci < 0 || v.o[P.ci] === cs[i]); })) return cs[i];
    }
    return cs[0];
  }
  var altColor = function (a) { return /^\s*colou?r\s*:/i.test(a || '') ? slug(String(a).replace(/^\s*colou?r\s*:\s*/i, '')) : null; };
  function imgOfColor(P, color) {
    if (P.ci < 0) return null;
    var v = P.v.filter(function (x) { return x.o[P.ci] === color && x.i; })[0];
    if (v) return v.i;
    var s = slug(color);
    var im = P.img.filter(function (i) { return altColor(i.a) === s; })[0];
    return im ? im.i : null;
  }
  function colorOfImg(P, id) {
    if (P.ci < 0 || !id) return null;
    var v = P.v.filter(function (x) { return x.i === id; })[0];
    if (v) return v.o[P.ci];
    var im = P.img.filter(function (i) { return i.i === id; })[0];
    var s = im && altColor(im.a);
    if (!s) return null;
    return P.opt[P.ci].v.filter(function (c) { return slug(c) === s; })[0] || null;
  }

  /* ---------- option picker (colour swatches + size chips) ---------- */
  function Picker(P, st, onchange) {
    var el = D.createElement('div');
    el.className = 'fg-pk';
    function fixSize() {
      if (P.si < 0) return;
      var sz = sizesFor(P, st.color);
      var cur = sz.filter(function (x) { return x.s === st.size && x.a; })[0];
      if (!cur) { var f = sz.filter(function (x) { return x.a; })[0]; st.size = f ? f.s : (sz[0] ? sz[0].s : null); }
    }
    function render() {
      fixSize();
      var h = '';
      if (P.ci >= 0 && P.opt[P.ci].v.length > 1) {
        h += '<div class="fg-pk__row"><div class="fg-pk__lab"><span>' + esc(P.opt[P.ci].n) + '</span><b>' + esc(st.color) + '</b></div><div class="fg-pk__sw">';
        P.opt[P.ci].v.forEach(function (c, i) {
          var out = !P.v.some(function (v) { return v.a && v.o[P.ci] === c; });
          h += '<button type="button" class="fg-pk__s' + (c === st.color ? ' is-on' : '') + (out ? ' is-out' : '') + '" data-pk-c="' + i + '" style="--c:' + esc((P.opt[P.ci].h || [])[i] || '#999') + '" aria-label="' + esc(c) + '" aria-pressed="' + (c === st.color) + '" title="' + esc(c) + '"></button>';
        });
        h += '</div></div>';
      }
      var sz = sizesFor(P, st.color);
      if (sz.length) {
        h += '<div class="fg-pk__row"><div class="fg-pk__lab"><span>' + esc(P.opt[P.si].n) + '</span><b>' + esc(st.size || '') + '</b></div><div class="fg-pk__chips">';
        sz.forEach(function (x, i) {
          h += '<button type="button" class="fg-pk__c' + (x.s === st.size ? ' is-on' : '') + (x.a ? '' : ' is-out') + '" data-pk-s="' + i + '"' + (x.a ? '' : ' disabled') + '>' + esc(x.s) + '</button>';
        });
        h += '</div></div>';
      }
      el.innerHTML = h;
    }
    el.addEventListener('click', function (e) {
      var c = e.target.closest('[data-pk-c]');
      var s = e.target.closest('[data-pk-s]');
      if (c) { st.color = P.opt[P.ci].v[+c.getAttribute('data-pk-c')]; render(); if (onchange) onchange('color'); }
      else if (s && !s.disabled) { st.size = sizesFor(P, st.color)[+s.getAttribute('data-pk-s')].s; render(); if (onchange) onchange('size'); }
    });
    render();
    return { el: el, render: render, variant: function () { return pickVariant(P, st.color, st.size); } };
  }

  /* ---------- product card ---------- */
  function cardState(card) {
    if (card.__st) return card.__st;
    var P = getData(card);
    if (!P) return null;
    var rail = $('[data-fg-rail]', card);
    var first = rail && rail.children[0] ? +rail.children[0].getAttribute('data-img') : 0;
    var st = { P: P, color: colorOfImg(P, first) || firstColor(P), rail: rail };
    card.__st = st;
    paintSw(card, st);
    return st;
  }
  function paintSw(card, st) {
    $$('[data-fg-sw]', card).forEach(function (b) {
      var on = b.getAttribute('data-fg-sw') === st.color;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on);
    });
    var nm = $('[data-fg-cname]', card);
    if (nm && st.color) nm.textContent = st.color;
  }
  var isRtl = function (el) { return getComputedStyle(el).direction === 'rtl'; };
  function railGo(rail, i) {
    var n = rail.children.length;
    i = Math.max(0, Math.min(n - 1, i));
    rail.scrollTo({ left: (isRtl(rail) ? -1 : 1) * i * rail.clientWidth, behavior: 'smooth' });
  }
  function railIdx(rail) { return Math.round(Math.abs(rail.scrollLeft) / (rail.clientWidth || 1)); }
  function renderSizes(card, st) {
    var box = $('[data-fg-sizes]', card);
    if (!box) return;
    var sz = sizesFor(st.P, st.color);
    box.innerHTML = '<span class="fg-pc__pick">' + T('Choose size', 'اختر المقاس') + '</span>' + sz.map(function (x, i) {
      return '<button type="button" class="fg-pc__size' + (x.a ? '' : ' is-out') + '"' + (x.a ? '' : ' disabled') + ' data-fg-size="' + i + '">' + esc(x.s) + '</button>';
    }).join('');
  }
  function flash(btn, txt, ok) {
    if (!btn) return;
    var old = btn.__old || btn.innerHTML;
    btn.__old = old;
    btn.classList.toggle('is-ok', !!ok);
    btn.classList.toggle('is-err', !ok);
    btn.innerHTML = txt;
    clearTimeout(btn.__t);
    btn.__t = setTimeout(function () { btn.innerHTML = old; btn.classList.remove('is-ok', 'is-err'); btn.__old = null; }, 1800);
  }
  function addVariant(card, v) {
    var btn = $('[data-fg-atc]', card);
    if (!v || !v.a) { flash(btn, T('Sold out', 'نفدت الكمية'), false); return; }
    card.classList.add('is-busy');
    Cart.add([{ id: v.id, quantity: 1 }]).then(function () {
      card.classList.remove('is-busy', 'is-pick');
      flash(btn, T('Added ✓', 'تمت الإضافة ✓'), true);
    }).catch(function (err) {
      card.classList.remove('is-busy');
      flash(btn, esc(err.message || T('Try again', 'حاول مرة أخرى')), false);
    });
  }

  D.addEventListener('click', function (e) {
    var t = e.target;
    var card = t.closest && t.closest('[data-fg-card]');
    if (!card) return;
    var sw = t.closest('[data-fg-sw]');
    var nav = t.closest('[data-fg-nav]');
    var dot = t.closest('[data-fg-dot]');
    var atc = t.closest('[data-fg-atc]');
    var size = t.closest('[data-fg-size]');
    if (!(sw || nav || dot || atc || size)) return;
    var st = cardState(card);
    if (!st) return;
    var P = st.P;
    if (sw) {
      e.preventDefault();
      st.color = sw.getAttribute('data-fg-sw');
      paintSw(card, st);
      var id = imgOfColor(P, st.color);
      var tgt = id && $('[data-img="' + id + '"]', st.rail);
      if (tgt) railGo(st.rail, Array.prototype.indexOf.call(st.rail.children, tgt));
      if (card.classList.contains('is-pick')) renderSizes(card, st);
    } else if (nav) {
      e.preventDefault();
      railGo(st.rail, railIdx(st.rail) + (+nav.getAttribute('data-fg-nav')));
    } else if (dot) {
      e.preventDefault();
      railGo(st.rail, +dot.getAttribute('data-fg-dot'));
    } else if (atc) {
      e.preventDefault();
      if (card.classList.contains('is-busy')) return;
      var sizes = sizesFor(P, st.color);
      var avail = sizes.filter(function (x) { return x.a; });
      if (P.si < 0 || sizes.length <= 1) {
        addVariant(card, pickVariant(P, st.color, sizes[0] ? sizes[0].s : null));
      } else if (card.classList.contains('is-pick')) {
        card.classList.remove('is-pick');
      } else {
        if (!avail.length) { flash(atc, T('Sold out', 'نفدت الكمية'), false); return; }
        renderSizes(card, st);
        card.classList.add('is-pick');
      }
    } else if (size) {
      e.preventDefault();
      var sz = sizesFor(P, st.color)[+size.getAttribute('data-fg-size')];
      addVariant(card, pickVariant(P, st.color, sz.s));
    }
  });

  /* rail scroll -> dots + swatch */
  D.addEventListener('scroll', function (e) {
    var rail = e.target;
    if (!rail || !rail.matches || !rail.matches('[data-fg-rail]')) return;
    clearTimeout(rail.__s);
    rail.__s = setTimeout(function () {
      var card = rail.closest('[data-fg-card]');
      if (!card) return;
      var i = railIdx(rail);
      $$('[data-fg-dot]', card).forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      var st = cardState(card);
      var slide = rail.children[i];
      var c = st && slide ? colorOfImg(st.P, +slide.getAttribute('data-img')) : null;
      if (c && c !== st.color) { st.color = c; paintSw(card, st); if (card.classList.contains('is-pick')) renderSizes(card, st); }
    }, 90);
  }, true);

  /* mark first dot */
  function boot(root) {
    $$('[data-fg-card]', root || D).forEach(function (c) {
      var d = $('[data-fg-dot]', c);
      if (d && !c.__booted) { c.__booted = true; d.classList.add('is-on'); }
    });
  }
  boot();
  if ('MutationObserver' in window) {
    new MutationObserver(function (m) { m.forEach(function (x) { if (x.addedNodes.length) boot(); }); }).observe(D.documentElement, { childList: true, subtree: true });
  }

  window.FagrShop = { Cart: Cart, Picker: Picker, money: money, T: T, esc: esc, slug: slug, getData: getData, pickVariant: pickVariant, sizesFor: sizesFor, firstColor: firstColor, imgOfColor: imgOfColor, colorOfImg: colorOfImg, colorsOf: colorsOf, isAr: isAr };
})();
